import { render, staticRenderFns } from "./create-companyinformation.vue?vue&type=template&id=7b7a9958&"
import script from "./create-companyinformation.vue?vue&type=script&lang=ts&"
export * from "./create-companyinformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-companyinformation.vue"
export default component.exports